export const APP_TYPES = [
  {
    id: 'admin',
    label: 'Admin',
    description: `Admin apps enhance your store's backend`,
  },
  {
    id: 'storefront',
    label: 'Storefront',
    description: `Storefront apps provide customer-facing features`,
  },
  {
    id: 'channel',
    label: 'Sales channel',
    description: `Sales channels enable you to sell on other platforms`,
  },
  {
    id: 'integration',
    label: 'Integration',
    description: `Integrations provide a connection between your store and another platform`,
  },
  {
    id: 'theme',
    label: 'Theme',
    description: `Themes provide a customizable look-and-feel for Storefront apps`,
  },
];

export { APP_CATEGORIES } from 'shared/app-categories';

export const APP_STOREFRONT_USE_CASES = [
  {
    id: 'direct_to_consumer',
    label: 'Direct to consumer',
    description: `Direct to consumer apps are designed for selling directly to consumers`,
  },
  {
    id: 'wholesale',
    label: 'Wholesale',
    description: `Wholesale apps are designed for selling to other businesses`,
  },
  {
    id: 'marketplace',
    label: 'Marketplace',
    description: `Marketplace apps are designed for selling products from multiple vendors`,
  },
  {
    id: 'digital_goods',
    label: 'Digital goods',
    description: `Digital goods apps are designed for selling digital products`,
  },
];

export const APP_STOREFRONT_PURCHASE_OPTIONS = [
  {
    id: 'standard',
    label: 'Standard',
    description: `Sell one-time purchases`,
  },
  {
    id: 'subscription',
    label: 'Subscription',
    description: `Sell recurring purchases on a schedule`,
  },
  {
    id: 'preorder',
    label: 'Preorder',
    description: `Sell products before they're available for delivery`,
  },
];

export const APP_STOREFRONT_FEATURES = [
  {
    id: 'multi_currency',
    label: 'Multi-currency',
    description: `Multi-currency apps support selling in multiple currencies`,
  },
  {
    id: 'multi_language',
    label: 'Multi-language',
    description: `Multi-language apps support selling in multiple languages`,
  },
  {
    id: 'bulk_pricing',
    label: 'Bulk pricing',
    description: `Bulk pricing apps support selling in bulk`,
  },
  {
    id: 'account_pricing',
    label: 'Account pricing',
    description: `Account pricing apps support selling to different customer groups`,
  },
];
